<template>
  <div :class="$style.wrapper">
    <div v-if="!disabled" :class="[$style.label, labelClass]">
      <Icon v-if="showIcon" name="check" />

      <Typography :variant="typography">
        {{ $i18n(label) }}
      </Typography>
    </div>

    <div :class="$style.content">
      <slot />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

import { Icon, Typography, TYPOGRAPHY_TYPES } from '@front/ui'

export default defineComponent({
  components: { Icon, Typography },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    labelClass: {
      type: [String, Object, Array],
      default: null,
    },
    label: {
      type: String,
      default: 'Recommandée',
    },
    typography: {
      type: String,
      default: TYPOGRAPHY_TYPES.bodyRegular,
    },
  },
})
</script>

<style lang="scss" module>
.wrapper {
  position: relative;
}

.label {
  position: absolute;
  height: 55px;
  top: -35px;
  left: 0px;
  display: flex;
  align-items: flex-start;
  gap: $ds-spacing-2xs;
  background-color: $ds-color-blue-dark;
  padding-left: $ds-spacing-xs;
  padding-right: $ds-spacing-xs;
  padding-top: $ds-spacing-2xs;
  padding-bottom: $ds-spacing-md;
  border-radius: $ds-radius-xs;
  width: fit-content;
  z-index: 1;
}

.content {
  position: relative;
  z-index: 2;
}
</style>
